import React, { useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import logo from '../assets/logo.png';
import './Navbar.css';

const servicesList = [
  { name: "Web Development", id: "web-development" },
  { name: "Mobile App Development", id: "mobile-app-development" },
  { name: "Payment Integration", id: "payment-integration" },
  { name: "Database Optimization", id: "database-optimization" },
  { name: "Website Designing", id: "website-designing" },
  { name: "Software Testing and Consultancy", id: "software-testing" },
  { name: "Penetration Testing", id: "penetration-testing" },
  { name: "Graphic Designing", id: "graphic-designing" }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const timeoutRef = useRef(null);
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setServicesDropdown(false);
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setServicesDropdown(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setServicesDropdown(false);
    }, 150);
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    closeMenu();

    if (location.pathname !== '/services') {
      navigate('/services');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleServiceSelect = (serviceId) => {
    closeMenu();

    if (location.pathname !== '/services') {
      navigate(`/services#${serviceId}`);
      setTimeout(() => {
        const el = document.getElementById(serviceId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 150);
    } else {
      const el = document.getElementById(serviceId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="container nav-flex">
        {/* Brand Logo */}
        <Link to="/" className="logo-container" onClick={closeMenu}>
          <img src={logo} alt="Stemiot Logo" className="nav-logo" />
          <div className="logo-text">
            <span className="brand-name">Stemiot</span>
            <span className="brand-sub">Softwares</span>
          </div>
        </Link>

        {/* Mobile Hamburger Toggle */}
        <div className="nav-actions-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>

        {/* Navigation Links */}
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          
          {/* Services with Hover Dropdown */}
          <li 
            className={`nav-dropdown-item ${servicesDropdown ? 'open' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <a 
              href="/services" 
              onClick={handleServicesClick} 
              className="services-nav-link"
            >
              Services <span className="dropdown-arrow">▾</span>
            </a>

            <div className="services-dropdown-menu">
              <div className="dropdown-arrow-up"></div>
              {servicesList.map((service, index) => (
                <button
                  key={index}
                  type="button"
                  className="dropdown-service-link"
                  onClick={() => handleServiceSelect(service.id)}
                >
                  {service.name}
                </button>
              ))}
            </div>
          </li>

          <li><Link to="/about" onClick={closeMenu}>About</Link></li>
          <li><Link to="/portfolio" onClick={closeMenu}>Portfolio</Link></li>
          <li><Link to="/pricing" onClick={closeMenu}>Pricing</Link></li>
          {/* <li><Link to="/blog" onClick={closeMenu}>Blog</Link></li> */}
          <li><Link to="/contact" className="btn-primary" onClick={closeMenu}>Get Started</Link></li>

          {/* Theme Mode Toggle Button */}
          {/* <li>
            <button
              onClick={toggleTheme}
              className="minimal-theme-btn"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? (
                <svg 
                  className="minimal-icon" 
                  viewBox="0 0 24 24" 
                  fill="#FFD700" 
                  stroke="#FFD700" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  style={{ width: '18px', height: '18px' }}
                >
                  <circle cx="12" cy="12" r="4" />
                  <path d="M12 2v2" />
                  <path d="M12 20v2" />
                  <path d="m4.93 4.93 1.41 1.41" />
                  <path d="m17.66 17.66 1.41 1.41" />
                  <path d="M2 12h2" />
                  <path d="M20 12h2" />
                  <path d="m6.34 17.66-1.41 1.41" />
                  <path d="m19.07 4.93-1.41 1.41" />
                </svg>
              ) : (
                <svg 
                  className="minimal-icon" 
                  viewBox="0 0 24 24" 
                  fill="#000000" 
                  stroke="#000000" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  style={{ width: '18px', height: '18px' }}
                >
                  <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
                </svg>
              )}
            </button>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;